
export const ridesTypesWavIds = [123]
